module.exports = __webpack_public_path__ + "static/img/icon_wx_app_code.6d70979.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_wx_app_code.jpg
// module id = qaoW
// module chunks = 1